import templateUrl from "emun.order/review-orders/review-orders-list.htm";
import controller from "emun.order/review-orders/review-orders-list.controller";

export default {
  controller,
  templateUrl($element, $attrs) {
    return $attrs.templateUrl || templateUrl;
  }
};
